// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Class naming: prop-driven classes are prefixed (cib-tone-*, cib-variant-*,
   cib-size-*) so they can never collide with element classes (cib-icon, cib-label). */

/* Each tone sets the button colour; the soft tint and hover colour are
   derived from it, so a custom \`color\` prop just works too. */
.cib-tone-primary  { --cib-color: var(--cui-primary); }
.cib-tone-success  { --cib-color: var(--cui-success); }
.cib-tone-danger   { --cib-color: var(--cui-danger); }
.cib-tone-warning  { --cib-color: var(--cui-warning); }
.cib-tone-info     { --cib-color: var(--cui-info); }
.cib-tone-neutral  { --cib-color: var(--cui-text-muted); }
.cib-tone-whatsapp { --cib-color: #25d366; }

.cib-btn {
  --cib-soft: color-mix(in srgb, var(--cib-color) 14%, #ffffff);
  --cib-hover: color-mix(in srgb, var(--cib-color) 82%, #000000);
  --cib-ring: color-mix(in srgb, var(--cib-color) 30%, transparent);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 0;
  border: 0;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: background var(--cui-transition), color var(--cui-transition),
    box-shadow var(--cui-transition), transform 0.05s ease;
}

.cib-btn:active:not(.cib-disabled) {
  transform: scale(0.95);
}

.cib-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--cib-ring);
}

.cib-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* The passed icon (lucide / MUI / SVG) is sized to the button */
.cib-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cib-icon > svg {
  width: var(--cib-icon-size);
  height: var(--cib-icon-size);
}

/* ---------- variant: round icon (soft tint → solid on hover) ---------- */
.cib-variant-icon {
  border-radius: 50%;
  background: var(--cib-soft);
  color: var(--cib-color);
}

.cib-variant-icon:hover:not(.cib-disabled) {
  background: var(--cib-color);
  color: #fff;
  box-shadow: 0 6px 14px -6px var(--cib-color);
}

.cib-variant-icon.cib-size-sm { width: 28px; height: 28px; --cib-icon-size: 15px; }
.cib-variant-icon.cib-size-md { width: 34px; height: 34px; --cib-icon-size: 17px; }
.cib-variant-icon.cib-size-lg { width: 42px; height: 42px; --cib-icon-size: 20px; }

/* ---------- variant: full (solid, with text) ---------- */
.cib-variant-full {
  border-radius: var(--cui-radius);
  background: var(--cib-color);
  color: #fff;
  box-shadow: 0 6px 16px -6px var(--cib-color);
}

.cib-variant-full:hover:not(.cib-disabled) {
  background: var(--cib-hover);
  color: #fff;
}

.cib-variant-full.cib-size-sm { min-height: 32px; padding: 5px 12px; font-size: 12.5px; --cib-icon-size: 14px; }
.cib-variant-full.cib-size-md { min-height: var(--cui-control-height); padding: 8px 16px; font-size: 13.5px; --cib-icon-size: 16px; }
.cib-variant-full.cib-size-lg { min-height: 48px; padding: 11px 22px; font-size: 15px; --cib-icon-size: 18px; }

/* Browsers without color-mix(): fall back to a fixed light tint */
@supports not (background: color-mix(in srgb, red 50%, white)) {
  .cib-btn {
    --cib-soft: var(--cui-bg-hover);
    --cib-hover: var(--cib-color);
    --cib-ring: var(--cui-primary-ring);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomIconButton/CustomIconButton.css"],"names":[],"mappings":"AAAA;sFACsF;;AAEtF;8DAC8D;AAC9D,qBAAqB,+BAA+B,EAAE;AACtD,qBAAqB,+BAA+B,EAAE;AACtD,qBAAqB,8BAA8B,EAAE;AACrD,qBAAqB,+BAA+B,EAAE;AACtD,qBAAqB,4BAA4B,EAAE;AACnD,qBAAqB,kCAAkC,EAAE;AACzD,qBAAqB,oBAAoB,EAAE;;AAE3C;EACE,6DAA6D;EAC7D,8DAA8D;EAC9D,iEAAiE;;EAEjE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf;0DACwD;AAC1D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,4CAA4C;AAC9C;;AAEA,gCAAgC,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE;AAClF,gCAAgC,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE;AAClF,gCAAgC,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE;;AAElF,2DAA2D;AAC3D;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA,gCAAgC,gBAAgB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AAC/G,gCAAgC,qCAAqC,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACpI,gCAAgC,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,qBAAqB,EAAE;;AAE9G,kEAAkE;AAClE;EACE;IACE,+BAA+B;IAC/B,6BAA6B;IAC7B,mCAAmC;EACrC;AACF","sourcesContent":["/* Class naming: prop-driven classes are prefixed (cib-tone-*, cib-variant-*,\n   cib-size-*) so they can never collide with element classes (cib-icon, cib-label). */\n\n/* Each tone sets the button colour; the soft tint and hover colour are\n   derived from it, so a custom `color` prop just works too. */\n.cib-tone-primary  { --cib-color: var(--cui-primary); }\n.cib-tone-success  { --cib-color: var(--cui-success); }\n.cib-tone-danger   { --cib-color: var(--cui-danger); }\n.cib-tone-warning  { --cib-color: var(--cui-warning); }\n.cib-tone-info     { --cib-color: var(--cui-info); }\n.cib-tone-neutral  { --cib-color: var(--cui-text-muted); }\n.cib-tone-whatsapp { --cib-color: #25d366; }\n\n.cib-btn {\n  --cib-soft: color-mix(in srgb, var(--cib-color) 14%, #ffffff);\n  --cib-hover: color-mix(in srgb, var(--cib-color) 82%, #000000);\n  --cib-ring: color-mix(in srgb, var(--cib-color) 30%, transparent);\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding: 0;\n  border: 0;\n  font-family: inherit;\n  font-weight: 600;\n  line-height: 1.2;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background var(--cui-transition), color var(--cui-transition),\n    box-shadow var(--cui-transition), transform 0.05s ease;\n}\n\n.cib-btn:active:not(.cib-disabled) {\n  transform: scale(0.95);\n}\n\n.cib-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--cib-ring);\n}\n\n.cib-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* The passed icon (lucide / MUI / SVG) is sized to the button */\n.cib-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cib-icon > svg {\n  width: var(--cib-icon-size);\n  height: var(--cib-icon-size);\n}\n\n/* ---------- variant: round icon (soft tint → solid on hover) ---------- */\n.cib-variant-icon {\n  border-radius: 50%;\n  background: var(--cib-soft);\n  color: var(--cib-color);\n}\n\n.cib-variant-icon:hover:not(.cib-disabled) {\n  background: var(--cib-color);\n  color: #fff;\n  box-shadow: 0 6px 14px -6px var(--cib-color);\n}\n\n.cib-variant-icon.cib-size-sm { width: 28px; height: 28px; --cib-icon-size: 15px; }\n.cib-variant-icon.cib-size-md { width: 34px; height: 34px; --cib-icon-size: 17px; }\n.cib-variant-icon.cib-size-lg { width: 42px; height: 42px; --cib-icon-size: 20px; }\n\n/* ---------- variant: full (solid, with text) ---------- */\n.cib-variant-full {\n  border-radius: var(--cui-radius);\n  background: var(--cib-color);\n  color: #fff;\n  box-shadow: 0 6px 16px -6px var(--cib-color);\n}\n\n.cib-variant-full:hover:not(.cib-disabled) {\n  background: var(--cib-hover);\n  color: #fff;\n}\n\n.cib-variant-full.cib-size-sm { min-height: 32px; padding: 5px 12px; font-size: 12.5px; --cib-icon-size: 14px; }\n.cib-variant-full.cib-size-md { min-height: var(--cui-control-height); padding: 8px 16px; font-size: 13.5px; --cib-icon-size: 16px; }\n.cib-variant-full.cib-size-lg { min-height: 48px; padding: 11px 22px; font-size: 15px; --cib-icon-size: 18px; }\n\n/* Browsers without color-mix(): fall back to a fixed light tint */\n@supports not (background: color-mix(in srgb, red 50%, white)) {\n  .cib-btn {\n    --cib-soft: var(--cui-bg-hover);\n    --cib-hover: var(--cib-color);\n    --cib-ring: var(--cui-primary-ring);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
